import { render, staticRenderFns } from "./Pembagian.vue?vue&type=template&id=47646f99"
import script from "./Pembagian.vue?vue&type=script&lang=js"
export * from "./Pembagian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports